import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-ink text-ivory mt-24 grain-overlay">
      <div className="max-w-editorial mx-auto px-6 sm:px-10 py-16">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-5">
            <Link to="/" className="inline-block">
              <span className="editorial-number text-brass text-3xl leading-none">N°</span>
              <span className="font-display text-4xl ms-3 italic">{t('header.title')}</span>
            </Link>
            <p className="mt-6 font-display text-xl italic text-linen/80 leading-snug max-w-sm">
              {t('footer.tagline')}
            </p>
          </div>

          <div className="col-span-6 md:col-span-2">
            <div className="editorial-label text-brass mb-4">{t('footer.explore')}</div>
            <ul className="space-y-2.5 font-body text-sm">
              <li>
                <Link to="/" className="text-linen/70 hover:text-ivory transition-colors">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-linen/70 hover:text-ivory transition-colors">
                  {t('footer.links.about')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-linen/70 hover:text-ivory transition-colors">
                  {t('footer.links.contact')}
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-linen/70 hover:text-ivory transition-colors">
                  {t('footer.links.faq')}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-linen/70 hover:text-ivory transition-colors">
                  {t('footer.links.terms')}
                </Link>
              </li>
              <li>
                <Link to="/cgv" className="text-linen/70 hover:text-ivory transition-colors">
                  {t('footer.links.cgv')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-linen/70 hover:text-ivory transition-colors">
                  {t('footer.links.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="text-linen/70 hover:text-ivory transition-colors">
                  {t('footer.links.legal')}
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="editorial-label text-brass mb-4">{t('footer.contact')}</div>
            <ul className="space-y-2.5 font-body text-sm">
              <li>
                <a
                  href="mailto:hello@handcrafted.local"
                  className="text-linen/70 hover:text-ivory transition-colors"
                >
                  hello@handcrafted.local
                </a>
              </li>
              <li>
                <a href="tel:+33123456789" className="text-linen/70 hover:text-ivory transition-colors">
                  +33 1 23 45 67 89
                </a>
              </li>
              <li className="text-linen/70 leading-relaxed pt-2">
                14, rue du Tailleur
                <br />
                75001 Paris
              </li>
            </ul>
          </div>

          <div className="col-span-12 md:col-span-2">
            <div className="editorial-label text-brass mb-4">{t('footer.hours')}</div>
            <ul className="space-y-2.5 font-body text-sm text-linen/70">
              <li>{t('footer.weekdays')}</li>
              <li>{t('footer.saturday')}</li>
              <li>{t('footer.sunday')}</li>
            </ul>
          </div>
        </div>

        <div className="editorial-rule mt-16 mb-6 bg-brass/40" />

        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="editorial-label text-linen/50">
            © {year} · {t('header.title')} · {t('footer.rights')}
          </div>
          <div className="editorial-number text-2xl text-brass">N°{year}</div>
        </div>
      </div>
    </footer>
  );
}
